import $ from 'jquery';
import Immutable from 'immutable';
import BasePropertyView from 'BasePropertyView.js';
import _template from 'properties/table/column-main-column.ejs';
import TextUtil from 'util/TextUtil.js';
import util         from 'util/Util.js';
import undoService from 'UndoService.js';
import textConstants        from 'TextConstants';
import constants from 'Constants.js';

class MainColumnView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = _template;
        this.tagName = 'div';
        this.id = opts.el;
        this.colId = this.model.get('selectedRowId');
        this.config = opts.config || {};

        this.events = {
            'change input[type=text]'       : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus',
            'change input[type=checkbox]'   : 'updateCheckAttributes',
            'change select'                 : 'updateSelectAttributes',
            'keydown input[name="width"]': 'validatePositiveNumeric'
        };

        if(this.colId){
            let factorykey=this.model.get('gridData')[this.colId].get('factoryKey');
            util.updateHelpDocumentationLink(factorykey);
        }

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    validatePositiveNumeric(ev){
        TextUtil.validatePositiveNumericNotPeriod(ev);
    }

    get columnModel() {
        return this.model.get('gridData')[this.colId];
    }

    setUndoRedo(propName, oldPropVal, propVal){

        undoService.add({
            undo: () => {        
                this.columnModel.attributes[propName] = oldPropVal;
                this.model.trigger('change');
            },
            redo: () => {
                this.columnModel.attributes[propName] = propVal;
                this.model.trigger('change');
            }
          }, textConstants.UNDO_MOVE);
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        let propVal  = util.sanitizeHTML(ev.currentTarget.value, true, this.model.get(propName));
        const oldPropVal  = this.columnModel.get(propName);

        // needs to set to the Column data within the GridData
        if(propName === 'width'){

            const width = parseInt(propVal);

            if(!width || width < constants.MIN_COLUMN_WIDTH){
                propVal = constants.MIN_COLUMN_WIDTH;
            }
        }

        this.columnModel.attributes[propName] = propVal;

        this.model.trigger('change');

        this.setUndoRedo(propName, oldPropVal, propVal);
       
    }

    updateCheckAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;
        const oldPropVal = this.columnModel.attributes[propName];

        var newValue = "";
        if (propVal) {
            newValue = "checked";
        }
        this.columnModel.attributes[propName] = newValue;

        // PF-5745
        this.setUndoRedo(propName, oldPropVal, propVal);
    }

    updateSelectAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        const oldPropVal  = this.columnModel.get(propName);

        this.columnModel.set(propName,propVal);
        this.setUndoRedo(propName, oldPropVal, propVal);
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        if (this.columnModel) {
            if (this.columnModel.attributes['factoryKey'] === 'textInputColumn' ||
                this.columnModel.attributes['factoryKey'] === 'numericInputColumn') {
                $('#column-footer-row-prop').removeClass('hide');
            }

            //Set Dropdowns
            if (this.columnModel.attributes['state']) {
                var ddValue = this.columnModel.attributes['state'];
                var ddl = $('#column-state');
                ddl.val(ddValue);
            }

            if (this.columnModel.attributes['footerfun']) {
                var ddValue = this.columnModel.attributes['footerfun'];
                var ddl = $('#table-column-footer-prop');
                ddl.val(ddValue);
            }

            if (this.config.showTitle) {
                this.$el.find('.propTitle').removeClass('hide');
            }

            if (this.config.mobileSharedMode) {
                this.$el.find('#propColumnWidth').addClass('hide');
                this.$el.find('#column-footer-row-prop').addClass('hide');
            } else if (this.config.mobileMode) {
                this.$el.find('#propColumnHeader').addClass('hide');
            }
        }

        this.addMultilanguageIcon();

        this.delegateEvents();
        return this;
    }

}

export default MainColumnView;
